<template>
  <vxe-column
    :width="columnWidth"
    class="operation-cell-content"
    fixed="right"
    title="business.label.operate"
    v-bind="$attrs"
  >
    <template #default="{row}">
      <vxe-button-group mode="text" status="primary" @click.stop>
        <!-- 固定按钮 -->
        <vxe-button
          v-for="(button,index) in fixedButtons"
          v-if="shouldShowButton(button, row)"
          :key="index"
          :content="button.content"
          :disabled="isButtonDisabled(button, row)"
          :status="button.status"
          @click.stop="click(button, row)"
        />

        <!-- 下拉按钮 -->
        <vxe-button v-if="showDropdowns" content="button.more" mode="text" status="success" @click.prevent>
          <template #dropdowns>
            <vxe-button
              v-for="(button,index) in dropdownButtons"
              v-if="shouldShowButton(button, row)"
              :key="index"
              :content="button.content"
              :disabled="isButtonDisabled(button, row)"
              :status="button.status || 'primary'"
              @click.stop="click(button, row)"
            />
          </template>
        </vxe-button>
      </vxe-button-group>
    </template>
  </vxe-column>
</template>

<script>
export default {
  name: 'OperateColumn',
  inheritAttrs: false,
  props: {
    // 固定按钮配置数组
    fixedButtons: {
      type: Array,
      default: () => []
    },
    // 下拉按钮配置数组
    dropdownButtons: {
      type: Array,
      default: () => []
    },
    // 列最小宽度
    minWidth: {
      type: Number,
      default: 100
    },
    // 每个按钮基础宽度
    buttonWidth: {
      type: Number,
      default: 40
    }
  },
  computed: {
    columnWidth() {
      const visibleFixedButtons = this.fixedButtons.filter(btn => !btn.hidden)
      const buttonCount = visibleFixedButtons.length + (this.dropdownButtons.length > 0 ? 1 : 0)
      const calculatedWidth = buttonCount * this.buttonWidth
      return Math.max(calculatedWidth, this.minWidth)
    },
    showDropdowns() {
      return this.dropdownButtons && this.dropdownButtons.length > 0
    }
  },
  methods: {
    shouldShowButton(button, row) {
      if (button.hidden === true) return false
      if (button.show === undefined) {
        return true
      } else {
        if (typeof button.show === 'function') {
          return button.show(row)
        } else {
          return button.show
        }
      }
    },
    isButtonDisabled(button, row) {
      if (button.disabled === undefined) {
        return false
      } else {
        if (typeof button.disabled === 'function') {
          return button.disabled(row)
        } else {
          return button.disabled
        }
      }
    },
    shouldShowDropdown(row) {
      if (!this.dropdownButtons || this.dropdownButtons.length === 0) {
        return false
      }
      return this.dropdownButtons.some(btn => this.shouldShowButton(btn, row))
    },
    getVisibleDropdownButtons(row) {
      return this.dropdownButtons.filter(btn => this.shouldShowButton(btn, row))
    },
    click(button, row) {// 统一处理按钮点击事件
      if (button.click) {
        button.click(row)// 如果有自定义点击事件，则触发
      } else if (button.method && this.$listeners[button.method]) {
        this.$emit(button.method, row)// 如果通过 method 定义，则触发父组件的方法
      } else if (this.$listeners['click']) {
        this.$emit('click', {
          key: button.key || button.content,
          row,
          button
        })// 触发通用的按钮点击事件
      }
    }
  }
}
</script>

<style scoped>
.operation-cell-content {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow: hidden;
}

.operation-cell-content .vxe-button {
  flex-shrink: 0;
  white-space: nowrap;
}
</style>